import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-811f1d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-table__wrap" }
const _hoisted_2 = { class: "invoice-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "概要/金額")
  ])
], -1))
const _hoisted_4 = { class: "invoice-detail-row__wrap" }
const _hoisted_5 = {
  colspan: "2",
  class: "invoice-detail-row__item"
}
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = { class: "invoice-detail-row__item--table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "数量"),
  /*#__PURE__*/_createElementVNode("th", null, "単価"),
  /*#__PURE__*/_createElementVNode("th", null, "金額")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tbody", { class: "row-space" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td")
  ])
], -1))
const _hoisted_10 = { class: "invoice-total-row__wrap" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "小計", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "消費税", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "合計", -1))
const _hoisted_14 = { class: "font-bolder" }

import { computed } from "vue";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardInvoiceTable',
  props: {
    companyInvoice: {}
  },
  setup(__props: any) {

const props = __props;



const calcDetailPrice = (quantity: number, unitPrice: number) => {
  return quantity * unitPrice;
};

// 小計
const subtotal = computed(() => {
  return props.companyInvoice.company_invoice_details.reduce((acc, detail) => {
    return acc + calcDetailPrice(detail.quantity, detail.unit_price);
  }, 0);
});

const consumptionTax = computed(() => {
  return subtotal.value * 0.1;
});

const total = computed(() => {
  return subtotal.value + consumptionTax.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyInvoice.company_invoice_details, (detail) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: detail.id
          }, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(detail.title), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("tbody", null, [
                    _createElementVNode("td", null, _toDisplayString(detail.quantity.toLocaleString()), 1),
                    _createElementVNode("td", null, _toDisplayString(detail.unit_price.toLocaleString()), 1),
                    _createElementVNode("td", null, " ￥" + _toDisplayString(calcDetailPrice(detail.quantity, detail.unit_price).toLocaleString()), 1)
                  ])
                ])
              ])
            ])
          ], 64))
        }), 128))
      ]),
      _hoisted_9,
      _createElementVNode("tbody", _hoisted_10, [
        _createElementVNode("tr", null, [
          _hoisted_11,
          _createElementVNode("td", null, "￥" + _toDisplayString(subtotal.value.toLocaleString()), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_12,
          _createElementVNode("td", null, "￥" + _toDisplayString(consumptionTax.value.toLocaleString()), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_13,
          _createElementVNode("td", _hoisted_14, "￥" + _toDisplayString(total.value.toLocaleString()), 1)
        ])
      ])
    ])
  ]))
}
}

})